import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";

import enviroments from "../../enviroments";

// console.log("enviroments", `${enviroments.API_URL_SOCKET}`);
const getConnectionHubAgendamento = () =>
  getNewHubConnectionBuilder("/agendamento");

const getConnectionHubCadastroLead = () =>
  getNewHubConnectionBuilder("/mobile");

const getNewHubConnectionBuilder = (hub: string) => {
  const toJson = localStorage.getItem("@token");
  const userData = toJson == null ? null : JSON.parse(toJson);

  return new HubConnectionBuilder()
    .withUrl(`${enviroments.API_URL_SOCKET}/hubs${hub}`, {
      skipNegotiation: true,
      transport: HttpTransportType.WebSockets,
      accessTokenFactory: () => userData.token,
    })
    .withAutomaticReconnect()
    .build();
};

export const hubsSocket = {
  getConnectionHubAgendamento,
  getConnectionHubCadastroLead,
};
